<template>
  <div class="d-flex flex-wrap">
    <div v-for="(item, i) in arr" :key="i">
      <v-card class="ma-1" :elevation="2" width="240">
        <div class="pa-4">
          <div>{{ item.title }}</div>
          <div class="d-flex justify-center">
            <audio controls style="width: 200px; height: 20px" controlsList="nodownload noplaybackrate">
              <source :src="item.url" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
const arr = [
  {
    title: "두둥탁 효과음",
    url: "/cdn/v1/assets/effects/sounds/dudungtack.mp3",
  },
  {
    title: "꽉 효과음",
    url: "/cdn/v1/assets/effects/sounds/quack.wav",
  },
  {
    title: "야이 효과음",
    url: "/cdn/v1/assets/effects/sounds/yai.wav",
  },
  {
    title: "아잉 효과음",
    url: "/cdn/v1/assets/effects/sounds/eeyye.wav",
  },
  {
    title: "마리오 파워업 효과음",
    url: "/cdn/v1/assets/effects/sounds/powerup.wav",
  },
  {
    title: "미끄덩 효과음",
    url: "/cdn/v1/assets/effects/sounds/slide.wav",
  },
  {
    title: "방구 효과음",
    url: "/cdn/v1/assets/effects/sounds/bangoo.wav",
  },
  {
    title: "팝팝 효과음",
    url: "/cdn/v1/assets/effects/sounds/pop.wav",
  },
  {
    title: "또잉",
    url: "/cdn/v1/assets/effects/sounds/doing.wav",
  },
];
export default {
  components: {},
  created() {},
  data() {
    return {
      arr,
    };
  },
};
</script>

<style></style>
